import { STATUSPAGE } from '@repo/ui';
import { AuthenticationPasswordResetVerifyCodeUseCaseInterface } from 'domain/usecases';
import { useFormik } from 'formik';
import { notifyError, notifySuccess } from 'presentation/app/components/notify';
import { usePasswordResetFlow } from 'presentation/app/contexts/PasswordResetFlowContext';
import { useService } from 'presentation/app/hooks/useService';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { useRequestResetPassword } from '../../send-password-reset-code/hooks/useRequestResetPassword';

export const useAuthenticationVerifyCode = () => {
  // hooks
  const navigate = useNavigate();
  const { requestSendPasswordResetCode } = useRequestResetPassword();
  const { authenticationService } = useService();
  const { setCodeVerified, state: flowState } = usePasswordResetFlow();
  const [loadingAuthenticationVerifyCode, setLoadingAuthenticationVerifyCode] =
    useState<STATUSPAGE>(STATUSPAGE.DONE);

  // validation
  const validationAuthenticationVerifyCode = useFormik({
    enableReinitialize: true,
    initialValues: {
      code: '',
    },
    validationSchema: Yup.object({
      code: Yup.string()
        .nullable()
        .required('O código é obrigatório')
        .min(6, 'Código incompleto.'),
    }),
    onSubmit: (values) => {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      requestAuthenticationVerifyCode({
        code: values.code,
        cpf: flowState.cpf!,
      });
    },
  });

  const requestAuthenticationVerifyCode = useCallback(
    (params: AuthenticationPasswordResetVerifyCodeUseCaseInterface.Params) => {
      setLoadingAuthenticationVerifyCode(STATUSPAGE.LOADING);
      authenticationService
        .authenticationPasswordResetVerifyCode(params)
        .then((res) => {
          setCodeVerified();
          navigate('/redefinir-senha/nova-senha');
          notifySuccess(
            res.message || 'Código de redefinição enviado com sucesso.',
          );
        })
        .catch((error: unknown) => {
          if (error instanceof Error) {
            notifyError(error.message || 'Código inválido.');
          }
        })
        .finally(() => {
          setLoadingAuthenticationVerifyCode(STATUSPAGE.DONE);
        });
    },
    [authenticationService, setCodeVerified, navigate],
  );

  return {
    requestSendPasswordResetCode,
    requestAuthenticationVerifyCode,
    loadingAuthenticationVerifyCode,
    validationAuthenticationVerifyCode,
  };
};
